import styled from 'styled-components';

export const Title = styled.span`
  color: #031795;
  font-weight: bold;
  font-size: 18px;
`